<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-refresh [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/organizations')"></med-icon-refresh></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.organizationsFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Напрям"
          label="Напрям"
          [(ngModel)]="filter.organizationsMZU.directions[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Область"
          label="Область"
          [(ngModel)]="filter.organizationsMZU.district[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Повна назва"
          label="Повна назва"
          [(ngModel)]="filter.organizationsMZU.name[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="ЄРПОУ"
          label="ЄРПОУ"
          [(ngModel)]="filter.organizationsMZU.edrpou[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Коротка назва"
          label="Коротка назва"
          [(ngModel)]="filter.organizationsMZU.shortName[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Адреса"
          label="Адреса"
          [(ngModel)]="filter.organizationsMZU.address[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Email"
          label="Email"
          [(ngModel)]="filter.organizationsMZU.email[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Контакти керівника"
          label="Контакти керівника"
          [(ngModel)]="filter.organizationsMZU.manager[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Контакти відповідальних осіб"
          label="Контакти відповідальних осіб"
          [(ngModel)]="filter.organizationsMZU.responsiblePersons[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Рівень"
          label="Рівень"
          [(ngModel)]="filter.organizationsMZU.level[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Тип"
          label="Тип"
          [(ngModel)]="filter.organizationsMZU.type[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Статус"
          label="Статус"
          [(ngModel)]="filter.organizationsMZU.status[0]"
          (focusout)="filter.organizationsMZUStateChange()"
        ></med-input>
      </div>
    </div>
  </div>
</p-sidebar>

<app-page-title></app-page-title>
<div class="table-wrapper">
<p-table [value]="organizationList"
         [tableStyle]="{ 'min-width': '50rem' }"
         styleClass="p-datatable-sm"
         [scrollable]="true"
         scrollHeight="flex"
         [customSort]="true"
         [lazy]="true"
         [resizableColumns]="true"
         columnResizeMode="expand"
         [columns]="tabHeader"
         [reorderableColumns]="true"
         (onLazyLoad)="loadData($event, true)"
         (onColResize)="handleColumnResize($event)"
         (onColReorder)="saveColumnOrder()">
    <ng-template pTemplate="header">
        <tr>
            <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" pReorderableColumn pResizableColumn>
                <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'min-width': ['fullName', 'contactPerson', 'headName'].includes(column.key) ? '15em': '5em', 'width': column.width}">
                    {{ column.label }}&nbsp;
                    <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                </div>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-organization let-columns="columns">
        <tr class="table-content-text">
            <ng-container *ngFor="let col of columns">
            <td class="h10-text black-80" *ngIf="col.key === 'directions'">
                <div class="flex-12rem">

            <ng-container *ngFor="let direction of organization.directions.split('~~')">
                {{ direction }}<br><br>
            </ng-container>

                </div>
            </td>
            <td class="h10-text black-60 no-wrap" *ngIf="col.key === 'district'">{{organization.district}}</td>
            <td class="h10-text black-80" *ngIf="col.key === 'name'">
                <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('name')">
                    <span>
                        {{organization.name}}
                    </span>
                </div>
            </td>
            <td class="h10-text black-60" *ngIf="col.key === 'edrpou'">{{organization.edrpou}}</td>
            <td class="h10-text black-80" *ngIf="col.key === 'shortName'">
                <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('shortName')">
                    <span>
                        {{organization.shortName}}
                    </span>
                </div>
            </td>
            <td class="h10-text black-80" *ngIf="col.key === 'address'">
                <div class="truncate-without-maxWidth" [style.width]="getWithForColumn('address')">
                    <span>
                        {{organization.address}}
                    </span>
                </div>
            </td>
            <td class="h10-text black-60 truncate" *ngIf="col.key === 'email'">
              {{ organization.email }}
            </td>
            <td class="h10-text black-80 truncate" *ngIf="col.key === 'manager'">
                <span >{{organization.manager}}</span>
                <br>
                <span class="h10-text black-40">
                    {{ organization.headPhone }}
                </span>
                <br>
<!--                <img *ngIf="organization.getHeadFullName() || organization.headPhone"-->
<!--                     src="assets/icons/table/copy_to_clipboard.svg"-->
<!--                     style="cursor: pointer"-->
<!--                     (mouseenter)="copyClip.show($event)" (mouseleave)="copyClip.hide()"-->
<!--                     (click)="copyToClipboard(organization.getHeadFullName() + ' ' + organization.headPhone)">-->
              <p-overlayPanel #copyClip>
                <div class="flex items-center h10-text">
                  Копіювати до буферу обміну
                </div>
              </p-overlayPanel>

            </td>
            <td class="h10-text black-80" *ngIf="col.key === 'responsiblePersons'">
            </td>
            <td class="h10-text black-60" *ngIf="col.key === 'subordinationId'"></td>
            <td class="h10-text black-80" *ngIf="col.key === 'type'">{{organization.type}}</td>

            <td class="h10-text black-80" *ngIf="col.key === 'status'">
              <img [src]="getPathStatusImg(organization.status)" width="4" height="16" style="vertical-align: middle;"/>
              {{organization.status == 'ACTIVE' ? 'Активна' : organization.status == 'INACTIVE' || !organization.status ? 'Неактивна' : ''}}
            </td>
        </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary">
        <div class="flex flex-center flex-between">
            <med-pagination
                    [total]="totalRows"
                    [page]="selectedPageNumber"
                    [perPage]="pageSize"
                    (pageChange)="pageChange($event)"
            ></med-pagination>

            <div class="small-text">
                Показано &nbsp;<strong>{{ getFirstShowedRowIndex() }}</strong>-<strong>{{ getFirstShowedRowIndex() + pageSize }}</strong> &nbsp;з {{ totalRows }}
            </div>

            <med-radio-group
                    mode="buttons"
                    [value]="totalRows"
                    [options]="paginationOptions"
                    (onInput)="pageSizeChanged($event)"
            ></med-radio-group>
        </div>
    </ng-template>
</p-table>
</div>
